
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Enums from '@/lib/enums'
    import { classPrintWorld } from '@/common/js/PrintWorld'
    class Pringting {
        printingNumber: number = 1;
    }
    @Component
    export default class EditLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        isLoadPrintList: boolean = false;
        PringtingModel: Pringting = new Pringting();
        isDisplay: boolean;
        needCert: boolean;
        created() {
            this.enterSearch();
        }
        enterSearch() {
            var _this = this;
            document.onkeydown = e => {
                //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
                //if (e.keyCode === 13 && _this.isDisplay) {
                //    //回车后执行搜索方法
                //   // _this.check();
                //}
                if (e.keyCode === 38 && _this.isDisplay) {
                    this.check();
                }
                else if (e.keyCode === 40 && _this.isDisplay) {
                    this.jumpto();
                }
            }
        }

        async pdfLinkToBase64(url) {
            try {
                // 使用fetch API获取PDF文件
                const response = await fetch(url);

                // 确保响应成功
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                // 将响应转换为ArrayBuffer
                const arrayBuffer = await response.arrayBuffer();

                // 将ArrayBuffer转换为Base64字符串
                const base64String = this.arrayBufferToBase64(arrayBuffer);

                return base64String;
            } catch (error) {
                console.error('Error fetching the PDF:', error);
                throw error; // 重新抛出错误以便上层调用者可以处理
            }
        }

        // 辅助函数：将ArrayBuffer转换为Base64字符串
        arrayBufferToBase64(buffer) {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }

        async check() {
            var barCode = this.$store.state.backstockproduct.barCode;
            var shelfPosition = this.$store.state.backstockproduct.shelfPosition;
            if (!this.isLoadPrintList) {
                var printWorld = new classPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
                var json = {
                    action: "", refresh: true, defaultprn: true, error: "", val: {}
                };
                json.action = "printers";
                json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
                json.defaultprn = true;                   //是否包含缺省打印机信息。
                json = printWorld.Direct(json);
                if (json == null) {//数据发送失败
                    alert(printWorld.GetLastError());
                } else if (json.error != undefined) {   //打天下打印服务返回的错误信息
                    alert(json.error);
                } else {    //处理包含打印机列表的json
                }


                var Options = new Array();
                for (var i in json.val) {
                    var option = document.createElement('option');
                    option.innerHTML = json.val[i].name;
                    option.value = json.val[i].name;
                    document.getElementById('SelectPrint').appendChild(option);
                }
                this.isLoadPrintList = true;
                this.$Message.success("已加载打印机，请选择指定打印机");
                return;
            }

            var pdfData = {
                barCode: barCode,
                shelfPosition: shelfPosition,
                imageUrl:"",
                url: '',
            };
            this.$store.commit('fontorder/getPdfUrl', pdfData);
            var printSelect: any = document.querySelector('#SelectPrint');
            if (!printSelect.value) {
                this.$Message.success("请选择指定打印机");
                return;
            }
            
            if (pdfData.url && pdfData.url.length > 0) {
                var jsonsList = [];
                var printWorld = new classPrintWorld(); //new 一个打天下对象
                for (var j = 0; j < this.PringtingModel.printingNumber; j++) {

               
                    var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                    var baseData = await this.pdfLinkToBase64(pdfData.url);
                    jsons.action = "printfile";
                    jsons.format = "file_base64";
                    jsons.content = "data:application/pdf;base64," + baseData;

                    //jsons.action = "printfile";      
                    //jsons.format = "pdf_url";        //指定格式为pdf_url。
                    //jsons.content = pdfData.url.replace("https","http");   //pdf文件的url路径
                    jsons.paperlength = 6;
                    jsons.paperwidth = 4;
                    if (this.needCert) {
                        jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                    }
                    jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                    jsonsList.push(jsons);
                }
                printWorld.Direct(jsonsList);
            }
        }

        async jumpto() {
            (this.$refs.printingForm as any).resetFields();
            this.$emit('input', false);
            var timestamp1 = (new Date()).valueOf().toString();
            setTimeout(() => {
                this.$router.push({ name: 'intoLogistics', params: { StockJumpPage: timestamp1 } });
            },500);
            //this.$nextTick(() => {
               
            //});
        }

        cancel() {
            (this.$refs.printingForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            this.isDisplay = value;
            if (!value) {
                this.$emit('input', value);
            } else {
                this.PringtingModel.printingNumber = this.$store.state.backstockproduct.printNumber;
               // this.PringtingModel.printingNumber = 2;
            }
        }
    }
